export default __webpack_public_path__ + "static/media/about-us.d8100266.webp";